// extracted by mini-css-extract-plugin
export var emailInputBubbleContainer = "_pl-0";